<template>

<div>
  <el-drawer
    title="应用切换"
    :visible.sync="drawer"
    size="30%"
  >
    <div style="margin: 0 20px;">
      <el-row :gutter="20">
        <el-col :span="12">
          <div @click="handleLogin" class="box-item">银企平台</div>
        </el-col>
        <el-col :span="12">
          <div @click="handleLogin" class="box-item">云中谷悦</div>
        </el-col>
        <el-col :span="12">
          <div @click="handleLogin" class="box-item">商户服务</div>
        </el-col>
        <el-col :span="12">
          <div @click="handleLogin" class="box-item">北京301</div>
        </el-col>
        <el-col :span="12">
          <div @click="handleLogin" class="box-item">蓝牙服务</div>
        </el-col>
        <el-col :span="12">
          <div @click="handleLogin" class="box-item">SDP服务</div>
        </el-col>
        <el-col :span="12">
          <div @click="handleLogin" class="box-item">银企平台</div>
        </el-col>
        <el-col :span="12">
          <div @click="handleLogin" class="box-item">银企平台</div>
        </el-col>
        <el-col :span="12">
          <div @click="handleLogin" class="box-item">银企平台</div>
        </el-col>
      </el-row>
    </div>
  </el-drawer>
</div>
</template>

<script>
  import bus from '@/utils/bus'

  export default {
    name: 'index',
    data() {
      return {
        drawer: false,
      }
    },


    mounted() {
      bus.$on('onDrawer', (red) => {
        this.drawer = red;
      })
    },

    beforeDestroy() {
      this.drawer = false;
    },
    methods: {
      handleLogin() {
        this.drawer = false;
        this.$notify({
          title: '切换成功',
          type: 'success',
          duration: 2000,
        });
      },

    }
  }
</script>

<style scoped>
  .box-item {
    display: flex;
    /*justify-content: center;*/
    align-items: center;
    border-radius: 4px;
    min-height: 30px;
    padding: 0 10px;
    background: #FAF9FA;
    cursor: pointer;
    margin-bottom: 10px;
    white-space: nowrap; /*强制文本一行显示*/
    overflow: hidden; /*超出元素默认宽度内容隐藏*/
    text-overflow: ellipsis; /*使用省略号代表有内容未显示*/
    font-size: 13px;
    line-height: 35px;
  }

  .box-item:hover {
    background: #f4f3f4;
  }
</style>



// WEBPACK FOOTER //
// src/components/RightPanel/index.vue